export default (state = [], action) => {
    switch (action.type) {
        case "SELECTED_INSTALLERS":
            return [...action.payload];
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/selectedInstallers_reducer.js